import * as React from 'react';
import { ConnectFragmentDumb } from '@helpcenter/connect-fragment';
import { Subject, Observable } from '@helpcenter/epics-rxjs';
import type { ConnectFragmentLocation } from 'state/selectors/connect-addon';
import { register, unregister, validate, serialize } from '@atlassian/help-center-common-util/connect/connect-api';

interface Props {
    fragmentHtml: string;
    connectKey: string;
    location: ConnectFragmentLocation;
}

export interface ConnectFieldResult {
    data: boolean | object | undefined;
    timedOut: boolean;
    connectKey: string;
}

class ConnectFieldDumb extends React.PureComponent<Props> {
    private validateSubject: Subject<ConnectFieldResult>;
    private serializeSubject: Subject<ConnectFieldResult>;

    onValidated = (isValid: boolean) => {
        this.validateSubject && this.validateSubject.next(this.connectFieldResult(isValid, false));
    };

    onSerialized = (data: object) => {
        this.serializeSubject && this.serializeSubject.next(this.connectFieldResult(data, false));
    };

    validate() {
        if (this.validateSubject) {
            this.validateSubject.unsubscribe();
        }

        this.validateSubject = new Subject<ConnectFieldResult>();

        validate(this.props.connectKey);

        return this.validateSubject.race(this.timeOutHandler()).first().toPromise();
    }

    serialize() {
        if (this.serializeSubject) {
            this.serializeSubject.unsubscribe();
        }

        this.serializeSubject = new Subject<ConnectFieldResult>();

        serialize(this.props.connectKey);

        return this.serializeSubject.race(this.timeOutHandler()).first().toPromise();
    }

    componentDidMount() {
        register(this.props.connectKey, this.onSerialized, this.onValidated);
    }

    componentWillUnmount() {
        unregister(this.props.connectKey);
    }

    render() {
        const { fragmentHtml, location, connectKey } = this.props;
        return <ConnectFragmentDumb fragmentHtml={fragmentHtml} location={location} fullKey={connectKey} />;
    }

    private connectFieldResult = (data: object | boolean | undefined, timedOut = false): ConnectFieldResult => ({
        data,
        timedOut,
        connectKey: this.props.connectKey,
    });

    private timeOutHandler = () => {
        const emitWhenTimeOut = Observable.of(this.connectFieldResult(undefined, true));

        return Observable.never().timeoutWith(1000, emitWhenTimeOut);
    };
}

export default ConnectFieldDumb;
